export default {
	title: '告警通知',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		requiredError: '必填项不能为空'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除',
		pushList: '推送列表'
	},
	table: {
		warnZone: '告警地点',
		warnSensor: '告警测点',
		warnContent: '告警内容',
		warnParameter: '告警参数',
		warnTime: '告警时间',
		pushTime: '推送时间',
		action: '操作'
	},
	form: {
		placeholder: {
			sensor: '告警测点',
			warnCategory: '告警分类'
		},
		label: {
			gearName: '齿轮名称',
			gearBrand: '齿轮品牌',
			bpfo: '外圈故障特征频率',
			bpfi: '内圈故障特征频率',
			bsf: '滚动体故障特征频率',
			ftf: '保持架故障特征频率'
		},
		options: {
			warnCategory: {
				alert: '告警',
				offline: '离线',
				abnormal: '异常'
			}
		}
	},
	config: {
		gridLayout: '格栅布局'
	},
	dialog: {
		add: '新增',
		update: '修改',
		pushList: '推送列表'
	},
	column: {
		pushType: '推送类型',
		recipientCode: '接收人识别码',
		pushResult: '推送结果'
	}
}
